export const API_TYPE_NIRVANA = 'nirvana';
export const API_TYPE_GZ = 'gz';
export const API_TYPE_ALERTS = 'alerts';
export const API_TYPE_PACKAGES = 'packages';
export const API_TYPE_QUARANTINE = 'quarantine';
export const API_TYPE_ACCOUNTS = 'accounts';
export const API_TYPE_EDR = 'edr';
export const API_TYPE_INTEGRITY_MONITOR_EVENTS = 'integrityMonitorEvents';
export const API_TYPE_COMPANIES_FOR_GZ_TAGS = 'companiesForGzTags';
export const API_TYPE_COMPANIES_FOR_MDR_CONTACT = 'companiesForMdrContact';
export const API_TYPE_COMPANIES_FOR_TELEMETRY_EXCLUSIONS = 'companiesWithSecurityTelemetryExclusions';
export const API_TYPE_ACCOUNTS_FOR_MDR_CONTACT = 'accountsForMdrContact';
export const API_TYPE_POLICY_EXCHANGE = 'policyExchange';
export const API_TYPE_EASM = 'companiesForEasm';
export const API_TYPE_PHASR = 'companiesForPhasr';
export const API_TYPE_PHASR_BEHAVIORAL_IDENTITIES = 'behavioralIdentitiesForPhasr';
export const API_TYPE_DASHBOARD = 'dashboard';
export const API_TYPE_DASHBOARD_ASM = 'dashboard_asm';
export const API_TYPE_DASHBOARD_EXECUTIVE_SUMMARY = 'dashboard_executive_summary';
export const API_TYPE_COMPANIES_FOR_ACCOUNTS = 'companiesForAccounts';
export const API_TYPE_INTEGRATION_PROFILES_FOR_VMWARE = 'integrationProfilesForVmware';
export const API_TYPE_AD_USERS_FOR_ACCOUNTS = 'ADUsersForAccounts';
export const API_TYPE_EPS = 'eps';
export const API_TYPE_SVE = 'sve';
export const API_TYPE_MDM = 'mdm';
export const API_TYPE_COMPANIES_FOR_GZ_PACKAGES = 'companiesForGzPackages';
export const API_TYPE_COMPANIES_FOR_GZ_FRAT_PACKAGES = 'companiesForFratGzPackages';
export const API_TYPE_RISK_MANAGEMENT = 'companiesForRiskManagement';
export const API_TYPE_POLICY_FILTER = 'policyFilter';
export const API_TYPE_COMPANY_FILTER = 'companyFilter';
export const API_TYPE_INTEGRATIONS_MARKETPLACE = 'integrationsMarketplace';
export const API_TYPE_RAW_EVENTS = 'rawEvents';

// Integrations - consider unifying these API TYPES
export const API_TYPE_COMPANIES_FOR_VMWARE_INTEGRATIONS = 'companiesForIntegrations';
export const API_TYPE_COMPANIES_FOR_CONTAINER_IMAGE_SCANNER_INTEGRATIONS =
  'companiesForContainerImageScannerIntegrations';

export const API_TYPE_DEVICE_FILTER_RISK_MANAGEMENT = 'deviceFilterForRiskManagement';
export const API_TYPE_USER_FILTER_RISK_MANAGEMENT = 'userFilterForRiskManagement';

// Compliance
export const WEB_COMPONENT_COMPLIANCE_APP = 'gz-compliance-app';
export const WEB_COMPONENT_COMPLIANCE_OVERVIEW = 'gz-compliance-overview';

// Issues
export const WEB_COMPONENT_BREACH_PATH_APP = 'gz-breach-path-app';
export const WEB_COMPONENT_BREACH_PATH_DETAILS = 'gz-breach-path-details';

// Executive Summary
export const WEB_COMPONENT_DASHBOARD_APP = 'gz-dashboard-app';
export const WEB_COMPONENT_DASHBOARD = 'gz-dashboard';
export const WEB_COMPONENT_WIDGET = 'gz-widget';
export const WEB_COMPONENT_WIDGET_OVERVIEW = 'gz-overview';
export const WEB_COMPONENT_WIDGET_TOP_THREATS = 'gz-top-threats';
export const WEB_COMPONENT_WIDGET_THREATS_BREAKDOWN = 'gz-threats-breakdown';
export const WEB_COMPONENT_WIDGET_INCIDENTS = 'gz-incidents';
export const WEB_COMPONENT_WIDGET_REMEDIATION_ACTIONS = 'gz-remediations';
export const WEB_COMPONENT_WIDGET_INVENTORY = 'gz-inventory';
export const WEB_COMPONENT_WIDGET_ACCESS_DATA_PROTECTION = 'gz-access-data-protection';
export const WEB_COMPONENT_WIDGET_ENDPOINT_MODULES_STATUS = 'gz-endpoint-modules-status';
export const WEB_COMPONENT_WIDGET_COMPANY_RISK_SCORE = 'gz-company-risk-score';
export const WEB_COMPONENT_WIDGET_WEBSITES_BLOCKED = 'gz-websites-blocked';
export const WEB_COMPONENT_WIDGET_NETWORK_ATTACK_TECHNIQUES = 'gz-network-attack-techniques';
export const WEB_COMPONENT_GZ_DASHBOARD_LOADING_SCREEN = 'gz-dashboard-loading-screen';
export const WEB_COMPONENT_WIDGET_ENDPOINT_MODULES_STATUS_DETAILS = 'gz-endpoint-modules-status-details';

// Executive Summary 2.0
export const WEB_COMPONENT_EXECUTIVE_SUMMARY_NETWORK_ATTACK_TECHNIQUES =
  'gz-executive-summary-network-attack-techniques';
export const WEB_COMPONENT_EXECUTIVE_SUMMARY_TOP_THREATS = 'gz-executive-summary-top-threats';
export const WEB_COMPONENT_EXECUTIVE_SUMMARY_WEBSITES_BLOCKED = 'gz-executive-summary-websites-blocked';
export const WEB_COMPONENT_EXECUTIVE_SUMMARY_INVENTORY = 'gz-executive-summary-inventory';
export const WEB_COMPONENT_EXECUTIVE_SUMMARY_THREATS_BREAKDOWN = 'gz-executive-summary-threats-breakdown';
export const WEB_COMPONENT_EXECUTIVE_SUMMARY_INCIDENTS = 'gz-executive-summary-incidents';
export const WEB_COMPONENT_EXECUTIVE_SUMMARY_REMEDIATION_ACTIONS = 'gz-executive-summary-remediations';
export const WEB_COMPONENT_EXECUTIVE_SUMMARY_COMPANY_RISK_SCORE = 'gz-executive-summary-company-risk-score';
export const WEB_COMPONENT_EXECUTIVE_SUMMARY_ACCESS_DATA_PROTECTION = 'gz-executive-summary-access-data-protection';
export const WEB_COMPONENT_EXECUTIVE_SUMMARY_OVERVIEW = 'gz-executive-summary-overview';
export const WEB_COMPONENT_EXECUTIVE_SUMMARY_ENDPOINT_MODULES_STATUS = 'gz-executive-summary-endpoint-modules-status';

// MSP EDR Trial Report
export const WEB_COMPONENT_MSP_EDR_TRIAL_REPORT = 'gz-msp-edr-trial-report';

// Threats Xplorer
export const WEB_COMPONENT_ALERTS_APP = 'gz-alerts-app';
export const WEB_COMPONENT_ALERTS = 'gz-alerts';
export const WEB_COMPONENT_GRID_VIEW = 'gz-grid-view';
export const WEB_COMPONENT_GRID_FILTERS = 'gz-grid-filters';
export const WEB_COMPONENT_GRID_FOOTER = 'gz-grid-footer';
export const WEB_COMPONENT_GRID_SETTINGS = 'gz-grid-settings';
export const WEB_COMPONENT_GRID_SMART_VIEWS = 'gz-grid-smart-views';
export const WEB_COMPONENT_GRID_SAVE_VIEW_FORM = 'gz-grid-save-view-form';
export const WEB_COMPONENT_ALERTS_DETAILS_PANEL = 'gz-alerts-details-panel';

// Generic Dashboard
export const WEB_COMPONENT_GENERIC_DASHBOARD_TOOLBAR = 'gz-dashboard-actions-toolbar';
export const WEB_COMPONENT_GZ_GENERIC_WIDGET = 'gz-generic-widget';
export const WEB_COMPONENT_GZ_GENERIC_WIDGET_CONTENT = 'gz-generic-widget-content';
export const WEB_COMPONENT_GZ_GRID_STACK_MANAGER = 'gz-dashboard-grid-stack-manager';
export const WEB_COMPONENT_GENERIC_DASHBOARD_SETTINGS_PANEL = 'gz-dashboard-settings-panel';
export const WEB_COMPONENT_FILTERS_BAR = 'gz-dashboard-filters-bar';
export const WEB_COMPONENT_DASHBOARD_MACRO_COMPONENT = 'gz-dashboard-macro-component';
export const WEB_COMPONENT_GENERIC_DASHBOARD_RESET_VIEW = 'gz-generic-dashboard-reset-view';
export const WEB_COMPONENT_GZ_GENERIC_DASHBOARD_APP = 'gz-generic-dashboard-app';

// Health Dashboard
export const WEB_COMPONENT_HEALTH_DASHBOARD_OVERVIEW = 'gz-health-dashboard-overview';
export const WEB_COMPONENT_HEALTH_DASHBOARD_UPDATE_STATUS = 'gz-health-dashboard-update-status';
export const WEB_COMPONENT_HEALTH_DASHBOARD_ENDPOINT_ISSUES = 'gz-health-dashboard-endpoint-issues';
export const WEB_COMPONENT_HEALTH_DASHBOARD_POLICIES = 'gz-health-dashboard-policies';
export const WEB_COMPONENT_HEALTH_DASHBOARD_LICENSES = 'gz-health-dashboard-licenses';
export const WEB_COMPONENT_HEALTH_DASHBOARD_MAC_OS_PERMISSIONS = 'gz-health-dashboard-mac-os-permissions';
export const WEB_COMPONENT_HEALTH_DASHBOARD_PATCH_MANAGEMENT = 'gz-health-dashboard-patch-management';
export const WEB_COMPONENT_HEALTH_DASHBOARD_ENDPOINT_MODULE_STATUS = 'gz-health-dashboard-endpoint-module-status';
export const WEB_COMPONENT_HEALTH_DASHBOARD_SECURITY_SERVER_STATUS = 'gz-health-dashboard-security-server-status';
export const WEB_COMPONENT_HEALTH_DASHBOARD_INVENTORY = 'gz-health-dashboard-inventory';
export const WEB_COMPONENT_HEALTH_DASHBOARD_ENDPOINT_ENCRYPTION = 'gz-health-dashboard-endpoint-encryption';
export const WEB_COMPONENT_HEALTH_DASHBOARD_INFO_OVERLAY = 'gz-health-dashboard-info-overlay';
export const WEB_COMPONENT_HEALTH_DASHBOARD_PRODUCT_UPDATE = 'gz-health-dashboard-product-update-status';
export const WEB_COMPONENT_HEALTH_DASHBOARD_SIGNATURE_UPDATE = 'gz-health-dashboard-signature-update-status';

// EASM Dashboard
export const WEB_COMPONENT_EASM_SCHEDULE_CONTROLLER = 'gz-easm-schedule-controller';
export const WEB_COMPONENT_EASM_ARTIFACTS_INVENTORY = 'gz-easm-artifacts-inventory';
export const WEB_COMPONENT_EASM_ASSETS_INVENTORY = 'gz-easm-assets-inventory';
export const WEB_COMPONENT_EASM_RECENT_ASSETS = 'gz-easm-recent-assets';
export const WEB_COMPONENT_EASM_PERIODIC_ASSETS = 'gz-easm-periodic-assets';
export const WEB_COMPONENT_EASM_PERIODIC_VULNERABILITIES = 'gz-easm-periodic-vulnerabilities';
export const WEB_COMPONENT_EASM_ASN_MAP = 'gz-easm-asn-map';
export const WEB_COMPONENT_EASM_VULNERABLE_SERVERS = 'gz-easm-vulnerable-servers';
export const WEB_COMPONENT_EASM_VULNERABLE_SERVICES = 'gz-easm-top-vulnerable-services';
export const WEB_COMPONENT_EASM_SERVICES_PER_PROTOCOL = 'gz-easm-services-per-protocol';
export const WEB_COMPONENT_EASM_CERTIFICATE_EXPIRATION = 'gz-easm-certificate-expiration';
export const WEB_COMPONENT_EASM_DNS_RECORDS = 'gz-easm-dns-records';
export const WEB_COMPONENT_EASM_TOP_VULNERABILITIES = 'gz-easm-top-vulnerabilities';
export const WEB_COMPONENT_EASM_TOP_OPEN_PORTS = 'gz-easm-top-open-ports';
export const WEB_COMPONENT_EASM_GENERIC_TOP_DATA = 'gz-easm-generic-top-data';

//EASM GRIDS AND SIDE MENUS
export const WEB_COMPONENT_EASM_ASSETS_INVENTORY_GRID = 'gz-easm-assets-inventory-grid';
export const WEB_COMPONENT_EASM_FINDING_DETAILS = 'gz-easm-finding-details';
export const WEB_COMPONENT_EASM_ARTIFACTS_INVENTORY_GRID = 'gz-easm-artifacts-inventory-grid';
export const WEB_COMPONENT_EASM_SIDE_MENU = 'gz-easm-side-menu';
export const WEB_COMPONENT_EASM_RELATED_FINDINGS = 'gz-easm-related-findings';

// Network V2
export const WEB_COMPONENT_NETWORK_V2_APP = 'gz-networkv2-app';
export const WEB_COMPONENT_NETWORK_APP_CONTAINER = 'gz-network-app-container';
export const WEB_COMPONENT_NETWORK_MALWARE_SCAN = 'gz-network-malware-scan';
export const WEB_COMPONENT_NETWORK_POP_UP_FOOTER = 'gz-network-pop-up-footer';
export const WEB_COMPONENT_NETWORK_TREE = 'gz-network-tree';
export const WEB_COMPONENT_NETWORK_TREE_SEARCH = 'gz-network-tree-search';
export const WEB_COMPONENT_NETWORK_IOC_SCAN = 'gz-network-ioc-scan';
export const WEB_COMPONENT_ACTION_ERROR = 'gz-network-action-error';
export const WEB_COMPONENT_IOC_SCAN_INDICATOR = 'gz-ioc-scan-indicator';
export const WEB_COMPONENT_REPAIR_AGENT = 'gz-repair-agent';
export const WEB_COMPONENT_GOLDEN_IMAGE_ASSIGNATION = 'gz-golden-image-assignation';
export const WEB_COMPONENT_PATCH_SCAN = 'gz-patch-scan';
export const WEB_COMPONENT_RESUME_INTEGRITY_MONITORING = 'gz-resume-integrity-monitoring';
export const WEB_COMPONENT_SUSPEND_INTEGRITY_MONITORING = 'gz-suspend-integrity-monitoring';
export const WEB_COMPONENT_ASSIGN_POLICY = 'gz-assign-policy';
export const WEB_COMPONENT_CHILD_GROUPS_GRID = 'gz-child-groups-grid';
export const WEB_COMPONENT_TARGETS_GRID = 'gz-targets-grid';
export const WEB_COMPONENT_RUN_NETWORK_DISCOVERY = 'gz-run-network-discovery';
export const WEB_COMPONENT_RISK_SCAN_ACTION = 'gz-risk-scan-action';
export const WEB_COMPONENT_UPDATE_SECURITY_SERVER = 'gz-network-update-security-server';
export const WEB_COMPONENT_RECOVERY_MANAGER = 'gz-recovery-manager';
export const WEB_COMPONENT_SUSPEND_PROTECTION = 'gz-suspend-protection';
export const WEB_COMPONENT_RESUME_PROTECTION = 'gz-resume-protection';

export const WEB_COMPONENT_NETWORK_INSTALL_PATCHES = 'gz-network-install-patches';
export const WEB_COMPONENT_PATCHES_GRID = 'gz-install-patches-grid';
export const WEB_COMPONENT_PATCHES_DETAILS_PANEL = 'gz-patches-details-panel';
export const WEB_COMPONENT_CVE_GRID = 'gz-patch-details-cve-grid';
export const WEB_COMPONENT_PRODUCTS_GRID = 'gz-patch-details-products-grid';
export const WEB_COMPONENT_RESTART_ENDPOINT = 'gz-restart-endpoint';
export const WEB_COMPONENT_ASSIGN_SECURITY_SERVERS = 'gz-assign-security-servers';
export const WEB_COMPONENT_NETWORK_UPDATE_AGENT = 'gz-network-update-agent';
// Companies
export const WEB_COMPONENT_COMPANIES_APP = 'gz-companies-app';
export const WEB_COMPONENT_COMPANIES_GRID = 'gz-companies-grid';

// Accounts
export const WEB_COMPONENT_ACCOUNTS_GRID = 'gz-accounts-grid';
export const WEB_COMPONENT_ADD_ACCOUNT_PANEL = 'gz-add-account-panel';
export const WEB_COMPONENT_EDIT_ACCOUNT_PANEL = 'gz-edit-account-panel';
export const WEB_COMPONENT_ACCOUNT_ROLE_AND_PRIVILEGES = 'gz-account-role-and-privileges';
export const WEB_COMPONENT_ACCOUNT_LOGIN_SECURITY = 'gz-account-login-security';
export const WEB_COMPONENT_ACCOUNT_DETAILS = 'gz-account-details';

// Company
export const WEB_COMPONENT_COMPANY_CREATE_PANEL = 'gz-company-create-panel';
export const WEB_COMPONENT_COMPANY_DETAILS_FORM = 'gz-company-details-form';
export const WEB_COMPONENT_COMPANY_AUTHENTICATION_FORM = 'gz-company-authentication-form';
export const WEB_COMPONENT_LICENSE_MAIN_FORM = 'gz-license-main-form';
export const WEB_COMPONENT_LICENSE_TRIAL_SUBFORM = 'gz-license-trial-subform';
export const WEB_COMPONENT_LICENSE_FRAT_SUBFORM = 'gz-license-frat-subform';
export const WEB_COMPONENT_LICENSE_PRE_PAID_SUBFORM = 'gz-license-pre-paid-subform';
export const WEB_COMPONENT_LICENSE_MONTHLY_LICENSE_TRIAL_SUBFORM = 'gz-license-monthly-license-trial-subform';
export const WEB_COMPONENT_LICENSE_BASIC_MONTHLY_SUBSCRIPTION_SUBFORM = 'gz-license-basic-monthly-subscription-subform';
export const WEB_COMPONENT_LICENSE_MONTHLY_SUBSCRIPTION_TRIAL_SUBFORM = 'gz-license-monthly-subscription-trial-subform';
export const WEB_COMPONENT_LICENSE_MONTHLY_SUBSCRIPTION_SUBFORM = 'gz-license-monthly-subscription-subform';
export const WEB_COMPONENT_LICENSE_MONTHLY_ADDONS_FORM = 'gz-license-monthly-addons-form';
export const WEB_COMPONENT_LICENSE_MONTHLY_BUNDLE_FORM = 'gz-license-monthly-bundle-form';
export const WEB_COMPONENT_LICENSE_MONTHLY_AVAILABLE_BUNDLES_FOR_AFFECTED_DESCENDANTS_FORM =
  'gz-license-monthly-available-bundles-for-affected-descendants-form';
export const WEB_COMPONENT_LICENSE_MONTHLY_RESELL_BUNDLE_FORM = 'gz-license-monthly-resell-bundle-form';
export const WEB_COMPONENT_LICENSE_MONTHLY_SERVICES_FORM = 'gz-license-monthly-services-form';
export const WEB_COMPONENT_CUSTOM_FIELDS_FORM = 'gz-custom-fields-form';

// My Company
export const WEB_COMPONENT_MY_COMPANY_PANEL = 'gz-my-company-panel';
export const WEB_COMPONENT_COMPANY_DETAILS_TAB = 'gz-company-details-tab';
export const WEB_COMPONENT_COMPANY_AUTHENTICATION_TAB = 'gz-company-authentication-tab';
export const WEB_COMPONENT_COMPANY_LICENSING_TAB = 'gz-company-licensing-tab';
export const WEB_COMPONENT_COMPANY_MSP_IN_PRODUCT_TRIALS_TAB = 'gz-company-msp-in-product-trials-tab';
export const WEB_COMPONENT_COMPANY_MSP_IN_PRODUCT_TRIALS_START_TRIAL_FORM =
  'gz-company-msp-in-product-trials-start-trial-form';
export const WEB_COMPONENT_CHANGE_PARTNER_MENU = 'gz-change-partner-menu';
export const WEB_COMPONENT_ADD_PRODUCT_MENU = 'gz-add-new-product-menu';
export const WEB_COMPONENT_COMPANY_BETA_PROGRAMS_TAB = 'gz-company-beta-programs-tab';
export const WEB_COMPONENT_PLANS_AND_PURCHASE_TAB = 'gz-company-plans-and-purchase-tab';

// Edit Company
export const WEB_COMPONENT_EDIT_COMPANY_PANEL = 'gz-edit-company-panel';
export const WEB_COMPONENT_EDIT_LICENSING_OPTIONS_MENU = 'gz-edit-licensing-options-menu';

// Packages
export const WEB_COMPONENT_PACKAGES = 'gz-packages';
export const WEB_COMPONENT_DOWNLOAD_SECURITY_CONTAINER = 'gz-download-security-container';
export const WEB_COMPONENT_DOWNLOAD_K8S_AGENT = 'gz-download-k8s-agent';
export const WEB_COMPONENT_DOWNLOAD_KIT_BUTTON = 'gz-download-kit-button';
export const WEB_COMPONENT_PACKAGE_GENERAL_FORM = 'gz-package-general-form';
export const WEB_COMPONENT_PACKAGE_MODULES_FORM = 'gz-package-modules-form';
export const WEB_COMPONENT_PACKAGE_DEPLOYER_FORM = 'gz-package-deployer-form';
export const WEB_COMPONENT_PACKAGE_USE_PROXY_FORM = 'gz-package-use-proxy-form';
export const WEB_COMPONENT_PACKAGE_SCAN_MODES_FORM = 'gz-package-scan-modes-form';
export const WEB_COMPONENT_PACKAGE_SETTINGS_FORM = 'gz-package-settings-form';
export const WEB_COMPONENT_PACKAGE_MISCELLANEOUS_FORM = 'gz-package-miscellaneous-form';
export const WEB_COMPONENT_PACKAGE_PANEL = 'gz-package-panel';
export const WEB_COMPONENT_PACKAGES_GRID = 'gz-packages-grid';
export const WEB_COMPONENT_SEND_DOWNLOAD_LINKS_FORM = 'gz-send-download-links-form';
export const WEB_COMPONENT_DEPLOYER_GRID = 'gz-deployer-grid';
export const WEB_COMPONENT_PACKAGE_SECURITY_SERVER_ASSIGNMENT_GRID = 'gz-package-security-server-assignment-grid';

// Endpoint
export const WEB_COMPONENT_WIDGET_ENDPOINT_INVESTIGATION_ACTIVITY_GRID = 'gz-endpoint-investigation-activity-grid';

// Sensors
export const WEB_COMPONENT_SENSORS_INTEGRATIONS_GRID = 'gz-sensors-integrations-grid';
export const WEB_COMPONENT_SENSORS_INTEGRATION_DETAILS_PANEL = 'gz-sensors-integration-details-panel';

// Global Exclusions
export const WEB_COMPONENT_EXPORT_EXCLUSIONS_PANEL = 'gz-export-exclusion-panel';

// Live Search
export const WEB_COMPONENT_LIVE_SEARCH_RESULTS_GRID = 'gz-live-search-results-grid';
export const WEB_COMPONENT_LIVE_SEARCH_METADATA_GRID = 'gz-live-search-metadata-grid';

//TARGETS
export const WEB_COMPONENT_TARGETS = 'gz-targets';

// Tags Manager
export const WEB_COMPONENT_TAGS_MANAGER = 'gz-tags-manager';
export const WEB_COMPONENT_TAGS_MANAGER_GRID = 'gz-tags-manager-grid';
export const WEB_COMPONENT_TAG_PANEL = 'gz-tag-panel';
export const WEB_COMPONENT_TAG_DETAILS_FORM = 'gz-tag-details-form';
export const WEB_COMPONENT_TAGS_NETWORK_FILTER = 'gz-tags-network-filter';
export const WEB_COMPONENT_GZ_TAGS_ENUM_LIST = 'gz-tags-enum-list';
export const WEB_COMPONENT_GZ_TAGS_ENUM_FILTER = 'gz-tags-enum-filter';
export const WEB_COMPONENT_INLINE_TAG_FORM = 'gz-inline-tag-form';

// In product trials
export const WEB_COMPONENT_IN_PRODUCT_TRIALS_APP = 'gz-in-product-trials-app';
export const WEB_COMPONENT_IN_PRODUCT_TRIALS_OVERLAY_WINDOW = 'gz-in-product-trials-overlay-window';
export const WEB_COMPONENT_IN_PRODUCT_TRIALS_OVERLAY_WINDOWS_APP = 'gz-in-product-trials-overlay-windows-app';
export const WEB_COMPONENT_MSP_IN_PRODUCT_TRIALS_OVERLAY_CONTENT = 'gz-msp-in-product-trials-overlay-content';
export const WEB_COMPONENT_MSP_IN_PRODUCT_TRIALS_OVERLAY_WINDOWS_APP = 'gz-msp-in-product-trials-overlay-windows-app';
export const WEB_COMPONENT_IN_PRODUCT_TRIALS_HEADER = 'gz-in-product-trials-header';
export const WEB_COMPONENT_IN_PRODUCT_TRIALS_VIDEO = 'gz-in-product-trials-video';

// Landing page
export const WEB_COMPONENT_GZ_LANDING_PAGE_APP = 'gz-landing-page-app';

// Risk Management (ERA/IOR)
export const WEB_COMPONENT_VULNERABILITIES_APP = 'gz-vulnerabilities-app';
export const WEB_COMPONENT_MISCONFIGURATIONS_APP = 'gz-misconfigurations-app';
export const WEB_COMPONENT_USER_BEHAVIOR_RISKS_APP = 'gz-user-behavior-risks-app';
export const WEB_COMPONENT_USERS_APP = 'gz-users-app';
export const WEB_COMPONENT_USER_BEHAVIOR_RISKS_SIDE_MENU = 'user-behavior-risks-side-menu';
export const WEB_COMPONENT_DEVICES_APP = 'gz-devices-app';
export const WEB_COMPONENT_MISCONFIGURATIONS_SIDE_MENU = 'misconfigurations-side-menu';
export const WEB_COMPONENT_VULNERABILITIES_SIDE_MENU = 'vulnerabilities-side-menu';
export const WEB_COMPONENT_USERS_SIDE_MENU = 'users-side-menu';
export const WEB_COMPONENT_DEVICES_SIDE_MENU = 'devices-side-menu';
export const WEB_COMPONENT_APPLICATION_CVE_LIST = 'gz-application-cve-list';

// Risk Management ASM Dashboard
export const WEB_COMPONENT_GZ_RM_COMPANY_STATE_WIDGET = 'gz-rm-company-state-widget';
export const WEB_COMPONENT_GZ_RM_SCORE_OVER_TIME_WIDGET = 'gz-rm-score-over-time-widget';
export const WEB_COMPONENT_GZ_RM_RESOURCES_BY_OS_WIDGET = 'gz-rm-resources-by-os-widget';
export const WEB_COMPONENT_GZ_RM_SCANNED_RESOURCES_WIDGET = 'gz-rm-scanned-resources-widget';
export const WEB_COMPONENT_GZ_RM_SCANNED_IDENTITIES_WIDGET = 'gz-rm-scanned-identities-widget';
export const WEB_COMPONENT_GZ_RM_TOP_FINDINGS_SEVERITY_WIDGET = 'gz-rm-top-findings-severity-widget';
export const WEB_COMPONENT_GZ_RM_TOP_VULNERABILITIES_SEVERITY_WIDGET = 'gz-rm-top-vulnerabilities-severity-widget';
export const WEB_COMPONENT_GM_RM_TOP_IDENTITY_RISKS_SEVERITY_WIDGET = 'gz-rm-top-identity-risks-severity-widget';
export const WEB_COMPONENT_GZ_RM_TOP_FINDINGS_IMPACT_WIDGET = 'gz-rm-top-findings-impact-widget';
export const WEB_COMPONENT_GZ_RM_TOP_VULNERABILITIES_IMPACT_WIDGET = 'gz-rm-top-vulnerabilities-impact-widget';
export const WEB_COMPONENT_GZ_RM_TOP_IDENTITY_RISK_IMPACT_WIDGET = 'gz-rm-top-identity-risks-impact-widget';
export const WEB_COMPONENT_GZ_RM_VULNERABILITIES_BREAKDOWN_WIDGET = 'gz-rm-vulnerabilities-breakdown-widget';
export const WEB_COMPONENT_GZ_RM_TOP_RESOURCES_RISK_WIDGET = 'gz-rm-top-resources-risk-widget';
export const WEB_COMPONENT_GZ_RM_TOP_IDENTITIES_RISK_WIDGET = 'gz-rm-top-identities-risk-widget';
export const WEB_COMPONENT_GZ_RM_TOP_VULNERABILITIES_INCIDENTS_WIDGET = 'gz-rm-top-vulnerabilities-incidents-widget';
export const WEB_COMPONENT_GZ_RM_TOP_RESOURCES_INCIDENTS_WIDGET = 'gz-rm-top-resources-incidents-widget';
export const WEB_COMPONENT_GZ_RM_CVES_SEVERITY_WIDGET = 'gz-rm-cves-severity-widget';
export const WEB_COMPONENT_GZ_RM_APPLICATIONS_SEVERITY_WIDGET = 'gz-rm-applications-severity-widget';
export const WEB_COMPONENT_GZ_RM_OLDEST_VULNERABILITIES_WIDGET = 'gz-rm-oldest-vulnerabilities-widget';
export const WEB_COMPONENT_GZ_RM_ZERO_TRUST_WIDGET = 'gz-rm-zero-trust-widget';

// Risk Management Generic UI Elements
export const WEB_COMPONENT_GZ_RM_SEVERITY = 'gz-rm-severity';
export const WEB_COMPONENT_GZ_RM_SEVERITY_BAR = 'gz-rm-severity-bar';
export const WEB_COMPONENT_GZ_RM_ICONS_LIST = 'gz-rm-icons-list';
export const WEB_COMPONENT_GZ_RM_ICON = 'gz-rm-icon';

// UI custom elements
export const WEB_COMPONENT_GZ_SELECT = 'gz-select';
export const WEB_COMPONENT_GZ_GAUGE = 'gz-gauge';
export const WEB_COMPONENT_GZ_COUNTER = 'gz-counter';
export const WEB_COMPONENT_GZ_PROGRESS = 'gz-progress';
export const WEB_COMPONENT_GZ_PROGRESS_THIN = 'gz-progress-thin';
export const WEB_COMPONENT_GZ_LOADER = 'gz-loader';
export const WEB_COMPONENT_GZ_TOOLTIP = 'gz-tooltip';
export const WEB_COMPONENT_GZ_TOOLTIP_BOX = 'gz-tooltip-box';
export const WEB_COMPONENT_GZ_DROPDOWN = 'gz-dropdown';
export const WEB_COMPONENT_GZ_DIALOG = 'gz-dialog';
export const WEB_COMPONENT_GZ_RADIO = 'gz-radio';
export const WEB_COMPONENT_GZ_RADIO_GROUP = 'gz-radio-group';
export const WEB_COMPONENT_BETA_PROGRAM_SECTION = 'beta-program-section';
export const WEB_COMPONENT_GZ_DROPDOWN_MENU = 'gz-dropdown-menu';
export const WEB_COMPONENT_GZ_BUTTON = 'gz-button';
export const WEB_COMPONENT_GZ_INPUT = 'gz-input';
export const WEB_COMPONENT_GZ_TEXTAREA = 'gz-textarea';
export const WEB_COMPONENT_GZ_INPUT_SEARCH = 'gz-input-search';
export const WEB_COMPONENT_GZ_CHECKBOX = 'gz-checkbox';
export const WEB_COMPONENT_GZ_ENUM_FILTER = 'gz-enum-filter';
export const WEB_COMPONENT_GZ_COMPANY_FILTER = 'gz-company-filter';
export const WEB_COMPONENT_GZ_ENDPOINT_FILTER = 'gz-endpoint-filter';
export const WEB_COMPONENT_GZ_OPERATING_SYSTEM_FILTER = 'gz-operating-system-filter';
export const WEB_COMPONENT_GZ_INPUT_NUMBER = 'gz-input-number';
export const WEB_COMPONENT_GZ_INPUT_FILE = 'gz-file-input';
export const WEB_COMPONENT_GZ_SIDE_MENU = 'gz-side-menu';
export const WEB_COMPONENT_GZ_ENUM_LIST = 'gz-enum-list';
export const WEB_COMPONENT_GZ_COMPANY_LIST = 'gz-company-list';
export const WEB_COMPONENT_GZ_ENDPOINT_LIST = 'gz-endpoint-list';
export const WEB_COMPONENT_COMPANY_SELECTOR = 'gz-company-selector';
export const WEB_COMPONENT_GZ_REMOVABLE = 'gz-removable';
export const WEB_COMPONENT_GZ_DATETIME_FILTER = 'gz-datetime-filter';
export const WEB_COMPONENT_GZ_TITLE = 'gz-title';
export const WEB_COMPONENT_GZ_TOGGLE = 'gz-toggle';
export const WEB_COMPONENT_GZ_PROGRESS_SPINNER = 'gz-progress-spinner';
export const WEB_COMPONENT_GZ_DATE_RANGE_PICKER = 'gz-date-range-picker';
export const WEB_COMPONENT_GZ_DATEPICKER_CALENDAR_CELL = 'gz-datepicker-calendar-cell';
export const WEB_COMPONENT_GZ_DATEPICKER_CALENDAR = 'gz-datepicker-calendar';
export const WEB_COMPONENT_GZ_IMAGE_REPO = 'gz-image-repo';
export const WEB_COMPONENT_GZ_TAB_GROUP = 'gz-tab-group';
export const WEB_COMPONENT_GZ_TAB = 'gz-tab';
export const WEB_COMPONENT_GZ_FORM_FIELD = 'gz-form-field';
export const WEB_COMPONENT_GZ_FORM_FIELD_TOGGLEABLE = 'gz-form-field-toggleable';
export const WEB_COMPONENT_GZ_INPUT_ERROR = 'gz-input-error';
export const WEB_COMPONENT_GZ_FORM_LIST = 'gz-form-list';
export const WEB_COMPONENT_GLOBAL_EXCLUSIONS_APP = 'gz-global-exclusions-app';
export const WEB_COMPONENT_CONFIGURATION_PROFILES = 'gz-configuration-profiles';
export const WEB_COMPONENT_GLOBAL_EXCLUSIONS = 'gz-global-exclusions';
export const WEB_COMPONENT_EXCLUSION_LISTS = 'gz-exclusion-lists';
export const WEB_COMPONENT_NEW_EXCLUSION_LIST = 'gz-new-exclusion-list';
export const WEB_COMPONENT_EXCLUSION_LIST_FORM = 'gz-exclusion-list-form';
export const WEB_COMPONENT_EXCLUSION_ITEM_FORM = 'gz-exclusion-item-form';
export const WEB_COMPONENT_EXCLUSION_ITEM_GRID = 'gz-exclusion-item-grid';
export const WEB_COMPONENT_GZ_WIZARD = 'gz-wizard';
export const WEB_COMPONENT_GZ_COPY_TO_CLIPBOARD = 'gz-copy-to-clipboard';
export const WEB_COMPONENT_GZ_ACCORDION = 'gz-accordion';
export const WEB_COMPONENT_GZ_ICON_BUTTON = 'gz-icon-button';
export const WEB_COMPONENT_GZ_LABELED_CONTENT = 'gz-labeled-content';
export const WEB_COMPONENT_GZ_TOAST_WRAPPER = 'gz-toast-wrapper';
export const WEB_COMPONENT_GZ_TOAST = 'gz-toast';
export const WEB_COMPONENT_GZ_LIST_ITEM = 'gz-list-item';
export const WEB_COMPONENT_EXCLUSION_LIST_DETAILS_PANEL = 'gz-exclusion-list-details-panel';
export const WEB_COMPONENT_POLICIES_SELECTOR = 'gz-policies-selector';
export const WEB_COMPONENT_IMPORTED_EXCLUSIONS_PREVIEW = 'gz-imported-exclusions-preview';
export const WEB_COMPONENT_EXCLUSION_LIST_SELECTOR = 'gz-exclusion-list-selector';
export const WEB_COMPONENT_GRID_CELL_EDIT = 'gz-grid-cell-edit';
export const WEB_COMPONENT_GZ_TABLE = 'gz-table';
export const WEB_COMPONENT_GZ_BASIC_TABLE = 'gz-basic-table';
export const WEB_COMPONENT_REMOTE_SHELL = 'gz-remote-shell';
export const WEB_COMPONENT_TERMINAL = 'gz-terminal';
export const WEB_COMPONENT_GZ_SPLIT_BUTTON = 'gz-split-button';
export const WEB_COMPONENT_ENDPOINT_DETAILS = 'gz-endpoint-details';
export const WEB_COMPONENT_GENERAL_DONUT_CHART = 'gz-general-donut-chart';
export const WEB_COMPONENT_GZ_LINK = 'gz-link';
export const WEB_COMPONENT_GZ_TEXT = 'gz-text';
export const WEB_COMPONENT_GZ_INFO_BOX = 'gz-info-box';
export const WEB_COMPONENT_GZ_MULTISELECT_ITEM = 'gz-multiselect-item';
export const WEB_COMPONENT_GZ_MULTISELECT_GROUP = 'gz-multiselect-group';
export const WEB_COMPONENT_IMPORTANT_MESSAGES = 'gz-important-messages';
export const WEB_COMPONENT_GZ_TIME_PICKER = 'gz-time-picker';
export const WEB_COMPONENT_GZ_DATE_PICKER = 'gz-date-picker';
export const WEB_COMPONENT_GZ_PUSH_BODY_LAYOUT = 'gz-push-body-layout';
export const WEB_COMPONENT_INLINE_ROW_ACTIONS = 'gz-inline-row-actions';
export const WEB_COMPONENT_SEARCH_QUERY = 'gz-search-query';
export const WEB_COMPONENT_INTEGRATION_CREATE_PANEL = 'gz-integrations-create-panel';
export const WEB_COMPONENT_SELECT_INTEGRATION = 'gz-integrations-integration-types-list';
export const WEB_COMPONENT_SELECT_COMPANY_INTEGRATION = 'gz-integrations-select-company';
export const WEB_COMPONENT_INTEGRATION_SAVED_SUCCESS = 'gz-integrations-success';
export const WEB_COMPONENT_INTEGRATION_EDIT_INTEGRATION = 'gz-integrations-edit-integration';
export const WEB_COMPONENT_INTEGRATION_REQUIREMENTS = 'gz-integrations-requirements';
export const WEB_COMPONENT_INTEGRATION_INFORMATION = 'gz-integrations-information';
export const WEB_COMPONENT_SENSOR_O365_MAIL = 'gz-integration-office-mail';
export const WEB_COMPONENT_SENSOR_O365_AUDIT = 'gz-integration-office-audit';
export const WEB_COMPONENT_SENSOR_AWS = 'gz-integration-aws';
export const WEB_COMPONENT_SENSOR_AZURE_AD = 'gz-integration-azure-ad';
export const WEB_COMPONENT_SENSOR_ATLASSIAN_AUDIT = 'gz-integration-atlassian-audit';
export const WEB_COMPONENT_SENSOR_ATLASSIAN_JIRA_CONFLUENCE = 'gz-integration-atlassian-jira-confluence';
export const WEB_COMPONENT_SENSOR_ATLASSIAN_JIRA_CONFLUENCE_GRID = 'gz-integration-atlassian-jira-confluence-grid';
export const WEB_COMPONENT_SENSOR_AZURE_CW = 'gz-integration-azure-cw';
export const WEB_COMPONENT_SENSOR_AD_ONPREM = 'gz-integration-add-onprem';
export const WEB_COMPONENT_SENSOR_INTUNE = 'gz-integration-intune';
export const WEB_COMPONENT_SENSOR_GOOGLE_WORKSPACE = 'gz-integration-google-workspace';
export const WEB_COMPONENT_SENSOR_GCP = 'gz-integration-gcp';
export const WEB_COMPONENT_FEEDBACK_CARD = 'gz-feedback-card';
export const WEB_COMPONENT_GZ_CARD = 'gz-card';
export const WEB_COMPONENT_XDR_SEARCH_QUERY_PANEL = 'gz-xdr-search-query-panel';
export const WEB_COMPONENT_XDR_LIVE_SEARCH_QUERY_PANEL = 'gz-xdr-live-search-query-panel';
export const WEB_COMPONENT_XDR_SEARCH_RESULTS_PANEL = 'gz-xdr-search-results-panel';
export const WEB_COMPONENT_XDR_SEARCH_APP = 'gz-xdr-search-app';
export const WEB_COMPONENT_XDR_SEARCH_TAB_PANEL = 'gz-xdr-search-tab-panel';
export const WEB_COMPONENT_XDR_SEARCH_LIVE = 'gz-xdr-search-live';
export const WEB_COMPONENT_XDR_SEARCH_EVENT_DETAILS_PANEL = 'gz-xdr-search-event-details-panel';
export const WEB_COMPONENT_GZ_CHIPS_ITEM = 'gz-chip';
export const WEB_COMPONENT_GZ_CHIPS_GROUP = 'gz-chips-group';
export const WEB_COMPONENT_MAINTENANCE_WINDOWS_APP = 'gz-maintenance-windows-app';
export const WEB_COMPONENT_MAINTENANCE_WINDOW_FORM = 'gz-maintenance-window-form';
export const WEB_COMPONENT_MAINTENANCE_WINDOW_SELECTOR = 'gz-maintenance-window-selector';
export const WEB_COMPONENT_MAINTENANCE_WINDOW_PREVIEW_PATCH_MANAGEMENT =
  'gz-maintenance-window-preview-patch-management';
export const WEB_COMPONENT_MAINTENANCE_WINDOW_GRID = 'gz-maintenance-window-grid';
export const WEB_COMPONENT_MAINTENANCE_WINDOW_FORM_PATCH_SPECIFICS = 'gz-maintenance-window-form-patch-specifics';
export const WEB_COMPONENT_MAINTENANCE_WINDOW_SCHEDULER = 'gz-maintenance-window-scheduler';
export const WEB_COMPONENT_MAINTENANCE_WINDOW_PATCH_MANAGEMENT_VENDOR_PRODUCT_SELECTOR =
  'gz-maintenance-window-patch-management-vendor-product-selector';
export const WEB_COMPONENT_MAINTENANCE_WINDOW_SIMPLE_SCHEDULER = 'gz-maintenance-window-simple-scheduler';
export const WEB_COMPONENT_RELAY_PATCH_CACHING_SERVERS = 'gz-relay-patch-caching-servers';
export const WEB_COMPONENT_MAINTENANCE_WINDOW_REBOOT_OPTIONS = 'gz-maintenance-window-reboot-options';
export const WEB_COMPONENT_MAINTENANCE_WINDOWS_SIDE_NAV = 'gz-maintenance-windows-side-nav';
export const WEB_COMPONENT_SUMMARY_PANEL = 'gz-summary-panel';
export const WEB_COMPONENT_LAYOUT = 'gz-dynamic-column-layout';
export const WEB_COMPONENT_XDR_OVERVIEW = 'gz-xdr-overview';
export const WEB_COMPONENT_TIMELINE_ITEM = 'gz-timeline-item';
export const WEB_COMPONENT_TIMELINE_GROUP = 'gz-timeline-group';
export const WEB_COMPONENT_TACTICS_AND_TECHNIQUES = 'gz-tactics-and-techniques';
export const WEB_COMPONENT_GZ_FLEXIBLE_TABLE = 'gz-flexible-table';
export const WEB_COMPONENT_GZ_CLIP_CONTENT = 'gz-clip-content';
export const WEB_COMPONENT_XDR_RESPONSE_GRID = 'gz-xdr-response-grid';
export const WEB_COMPONENT_RESPONSE_PANEL = 'gz-response-panel';
export const WEB_COMPONENT_RESPONSE_PANEL_ITEM = 'gz-response-panel-item';
export const WEB_COMPONENT_RISK_INCIDENT_PANEL = 'gz-risk-incident-panel';
export const WEB_COMPONENT_RISK_INCIDENT_SECTION = 'gz-risk-incident-section';
export const WEB_COMPONENT_INTEGRATION_TYPE_CARD = 'gz-integration-type-card';
export const WEB_COMPONENT_GZ_COLLAPSABLE_CONTAINER = 'gz-collapsable-container';
export const WEB_COMPONENT_GZ_PAGINATION = 'gz-pagination';
export const WEB_COMPONENT_GRID_VIEW_TITLE = 'gz-grid-view-title';
export const WEB_COMPONENT_EXCHANGE_PROTECTION = 'gz-quarantine-exchange-protection';
export const WEB_COMPONENT_EXCHANGE_PROTECTION_DETAILS_PANEL = 'gz-quarantine-exchange-protection-details-panel';
export const WEB_COMPONENT_COMPUTERS_AND_VIRTUAL_MACHINES = 'gz-quarantine-computers-and-virtual-machines';
export const WEB_COMPONENT_QUARANTINE_COMPUTERS_AND_VIRTUAL_MACHINES_RESTORE_FORM =
  'gz-quarantine-computers-and-virtual-machines-restore-form';
export const WEB_COMPONENT_QUARANTINE_SAVE_FORM = 'gz-quarantine-save-form';
export const WEB_COMPONENT_QUARANTINE_DOWNLOAD_FORM = 'gz-quarantine-download-form';
export const WEB_COMPONENT_GRID_SELECTION_EXTRA_OPTIONS = 'gz-grid-selection-extra-options';
export const WEB_COMPONENT_LIGHT_GRID = 'gz-light-grid';
export const WEB_COMPONENT_GZ_JSON_VIEWER = 'gz-json-viewer';
export const WEB_COMPONENT_MAINTENANCE_WINDOWS_DELETE_DIALOG = 'gz-maintenance-windows-delete-dialog';
export const WEB_COMPONENT_GZ_TREE = 'gz-tree';
export const WEB_COMPONENT_GZ_NODE_DIRECTOR = 'gz-node-director';
export const WEB_COMPONENT_GZ_NODE_RENAME_INPUT = 'gz-node-rename-input';
export const WEB_COMPONENT_RAW_EVENTS_CONFIGURATION_GRID = 'gz-raw-events-configuration-grid';
export const WEB_COMPONENT_INTEGRITY_MONITOR_EVENTS = 'gz-integrity-monitor-events';
export const WEB_COMPONENT_INTEGRITY_MONITOR_EVENTS_DETAILS_PANEL = 'gz-integrity-monitor-events-details-panel';
export const WEB_COMPONENT_INTEGRITY_MONITOR_REAL_TIME_PANEL = 'gz-integrity-monitor-real-time-panel';
export const WEB_COMPONENT_INTEGRITY_MONITOR_PAUSE = 'gz-integrity-monitor-pause';
export const WEB_COMPONENT_INTEGRITY_MONITOR_POLICY_RULE_SETS_SECTION = 'gz-integrity-monitor-policy-rule-sets-section';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULES_APP = 'gz-integrity-monitor-rules-app';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULES_SMART_VIEWS = 'gz-integrity-monitor-rules-smart-views';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULES_GRID = 'gz-integrity-monitor-rules-grid';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULE_SET_FORM = 'gz-integrity-monitor-rule-set-form';
export const WEB_COMPONENT_INTEGRITY_MONITOR_ASSIGN_RULES_FORM = 'gz-integrity-monitor-assign-rules-form';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULES_ADD_CUSTOM_RULE = 'gz-integrity-monitor-add-custom-rule';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_MAIN_FORM = 'gz-integrity-monitor-custom-rule-main-form';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTIONS_FORM =
  'gz-integrity-monitor-custom-rule-actions-form';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_ACTION_ITEM =
  'gz-integrity-monitor-custom-rule-action-item';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_DIRECTORY_FORM =
  'gz-integrity-monitor-custom-rule-directory-form';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_FILE_FORM = 'gz-integrity-monitor-custom-rule-file-form';
export const WEB_COMPONENT_INTEGRITY_MONITOR_DEFAULT_RULE_CONFIGURATION =
  'gz-integrity-monitor-default-rule-configuration';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_REGISTRYKEY_FORM =
  'gz-integrity-monitor-custom-registrykey-file-form';
export const WEB_COMPONENT_INTEGRITY_MONITOR_RULES_CUSTOM_RULE_REGISTRYVALUE_FORM =
  'gz-integrity-monitor-custom-registryvalue-file-form';
export const WEB_COMPONENT_GRID_CELL_DEFAULT_RENDERER = 'gz-grid-cell-default-renderer';
export const WEB_COMPONENT_SUSPEND_COMPANY_CONFIRMATION = 'gz-suspend-company-confirmation';
export const WEB_COMPONENT_ACTIVATE_COMPANY_CONFIRMATION = 'gz-activate-company-confirmation';
export const WEB_COMPONENT_GZ_GENERIC_DETAILS_SECTION = 'gz-generic-details-sections';
export const WEB_COMPONENT_NOTES_PANEL = 'gz-notes-panel';
export const WEB_COMPONENT_NOTES_LIST = 'gz-notes-list';
export const WEB_COMPONENT_NOTE_CARD = 'gz-note-card';
export const WEB_COMPONENT_NOTE_EDITOR = 'gz-note-editor';
export const WEB_COMPONENT_INCIDENT_HISTORY = 'gz-incident-history';
export const WEB_COMPONENT_CARD_HISTORY = 'gz-card-history';
export const WEB_COMPONENT_INCIDENTS_GRID = 'gz-incidents-grid';
export const WEB_COMPONENT_GZ_COUNT_DOWN = 'gz-count-down';
export const WEB_COMPONENT_GZ_SLIDER = 'gz-slider';
export const WEB_COMPONENT_GZ_RANGE_SLIDER_INPUT = 'gz-range-slider-input';
export const WEB_COMPONENT_GZ_DYNAMIC_FORM_WRAPPER = 'gz-dynamic-form-wrapper';
export const WEB_COMPONENT_GZ_DYNAMIC_FORM_INPUT = 'gz-dynamic-form-input';
export const WEB_COMPONENT_GZ_SINGLE_SELECT = 'gz-single-select';
export const WEB_COMPONENT_GZ_SINGLE_SELECT_LIST = 'gz-single-select-list';
export const WEB_COMPONENT_GZ_SINGLE_SELECT_COMPLEX = 'gz-single-select-complex';
export const WEB_COMPONENT_GZ_REPORTING_PERIOD = 'gz-reporting-period';
export const WEB_COMPONENT_GENERIC_GRID_SMART_VIEWS = 'gz-generic-grid-smart-views';
export const WEB_COMPONENT_GENERIC_SMART_VIEWS_LIST = 'gz-generic-smart-views-list';
export const WEB_COMPONENT_GZ_ICON_LABEL = 'gz-icon-label';
export const WEB_COMPONENT_INCIDENTS_SIDE_MENU = 'gz-incidents-side-menu';
export const WEB_COMPONENT_ORGANIZATIONAL_IMPACT = 'gz-organizational-impact';
export const WEB_COMPONENT_LIVE_SEARCH_METADATA = 'gz-live-search-metadata';
export const WEB_COMPONENT_XDR_INCIDENT_DETAILS = 'gz-xdr-incident-details';
export const WEB_COMPONENT_EDR_INCIDENT_DETAILS = 'gz-edr-incident-details';
export const WEB_COMPONENT_INCIDENT_DETAILS_ANALYSIS_SECTION = 'gz-incident-details-analysis-section';
export const WEB_COMPONENT_INCIDENT_GENERAL_SECTION = 'gz-incident-general-section';
export const WEB_COMPONENT_INCIDENT_ATTACK_INFO = 'gz-incident-attack-info';
export const WEB_COMPONENT_SHOW_MORE_ITEMS = 'gz-show-more-items';
export const WEB_COMPONENT_INCIDENT_DETAILS_DETECTIONS_SECTION = 'gz-incident-details-detections-section';
export const WEB_COMPONENT_INCIDENT_DETAILS_TECHNIQUES_SECTION = 'gz-incident-details-techniques-section';
export const WEB_COMPONENT_SHOW_MORE_ITEMS_IN_BULK_WEB_COMPONENT = 'gz-show-more-items-in-bulk';
export const WEB_COMPONENT_EDR_RESPONSE_GRID = 'gz-edr-response-grid';
export const WEB_COMPONENT_GRID_SUMMARY = 'gz-grid-summary';
export const WEB_COMPONENT_GZ_DASHBOARD_SMART_VIEWS_LIST = 'gz-dashboard-smart-views-list';
export const WEB_COMPONENT_GZ_DASHBOARD_SAVE_AS_DIALOG_CONTENT = 'gz-dashboard-save-as-dialog-content';
export const WEB_COMPONENT_GZ_DASHBOARD_DELETE_VIEW_DIALOG_CONTENT = 'gz-dashboard-delete-view-dialog-content';
export const WEB_COMPONENT_GZ_DASHBOARD_DISCARD_CHANGES_DIALOG_CONTENT = 'gz-dashboard-discard-changes-dialog-content';
export const WEB_COMPONENT_GZ_DASHBOARD_UNSAVED_CHANGES_DIALOG_CONTENT = 'gz-dashboard-unsaved-changes-dialog-content';
export const WEB_COMPONENT_GZ_DASHBOARD_FEEDBACK_DIALOG_CONTENT = 'gz-dashboard-feedback-dialog-content';
export const WEB_COMPONENT_GZ_DASHBOARD_SMART_VIEWS_TOOLBAR = 'gz-dashboard-smart-views-toolbar';
export const WEB_COMPONENT_GZ_ENUMERATION_ICON = 'gz-enumeration-icon';
export const WEB_COMPONENT_GZ_BANNER = 'gz-banner';
export const WEB_COMPONENT_MDR_CUSTOMER_PANEL = 'gz-mdr-customer-panel';
export const WEB_COMPONENT_MOBILE_SECURITY_CUSTOMER_VIEW = 'gz-mobile-security-customer-view';
export const WEB_COMPONENT_MOBILE_SECURITY_GRID = 'gz-mobile-security-grid';
export const WEB_COMPONENT_MOBILE_SECURITY_ACTIVATION_EMAILS_DIALOG_BODY =
  'gz-mobile-security-activation-emails-dialog-body';
export const WEB_COMPONENT_MOBILE_SECURITY_APP = 'gz-mobile-security-app';
export const WEB_COMPONENT_CLOUD_WORKLOAD_SECURITY_APP = 'gz-cloud-workload-security-app';
export const WEB_COMPONENT_GZ_INFO_OVERLAY = 'gz-info-overlay';
export const WEB_COMPONENT_GZ_CHIPS_GENERATOR_INPUT = 'gz-chips-generator-input';
export const WEB_COMPONENT_GZ_TRIAL_PRODUCT_ITEM = 'gz-trial-product-item';
export const WEB_COMPONENT_GZ_TRIAL_HOME_PAGE = 'gz-trial-home-page';
export const WEB_COMPONENT_MSP_LANDING_PAGE = 'gz-msp-landing-page';
export const WEB_COMPONENT_B2B_LANDING_PAGE = 'gz-landing-page';
export const WEB_COMPONENT_SCHEMA_HELPER = 'gz-schema-helper';
export const WEB_COMPONENT_NETWORK_TASKS = 'gz-network-tasks';
export const WEB_COMPONENT_NETWORK_SUB_TASKS = 'gz-network-sub-tasks';
export const WEB_COMPONENT_SUBTASKS_DETAILS_PANEL = 'gz-subtask-details-panel';
export const WEB_COMPONENT_UPLOAD_WINDOW = 'gz-upload-window';
export const WEB_COMPONENT_DOWNLOAD_WINDOW = 'gz-download-window';
export const WEB_COMPONENT_GZ_BULK_ACTIONS_BAR = 'gz-bulk-actions-bar';
export const WEB_COMPONENT_RECONFIGURE_AGENT_PANEL = 'gz-reconfigure-agent-panel';
export const WEB_COMPONENT_RECONFIGURE_AGENT_TYPE_FORM = 'gz-reconfigure-agent-type-form';
export const WEB_COMPONENT_RECONFIGURE_AGENT_SCHEDULER_FORM = 'gz-reconfigure-agent-scheduler-form';
export const WEB_COMPONENT_INSTALL_AGENT_PANEL = 'gz-install-agent-panel';
export const WEB_COMPONENT_INSTALL_AGENT_ADDITIONAL_TARGETS = 'gz-install-agent-additional-targets';
export const WEB_COMPONENT_CREDENTIALS_MANAGER_GRID = 'gz-credentials-manager-grid';
export const WEB_COMPONENT_DOWNLOAD_TYPE_FORM = 'gz-download-type-form';
export const WEB_COMPONENT_GZ_HEADER = 'gz-header';
export const WEB_COMPONENT_GZ_WIDGET_SECTION_ITEM = 'gz-widget-section-item';
export const WEB_COMPONENT_RISK_INCIDENT_OVERVIEW_ITEM = 'gz-risk-overview-section-item';
export const WEB_COMPONENT_GZ_WIDGET_HEADER_ITEM = 'gz-widget-header-item';
export const WEB_COMPONENT_WIDGET_PRODUCT_ITEM = 'gz-widget-product-item';
export const WEB_COMPONENT_GZ_WIDGET_PRODUCT_ITEM = 'gz-gz-widget-product-item';
export const WEB_COMPONENT_GZ_DASHBOARD_TITLE_WITH_FEED_BACK_TOOLBAR = 'gz-dashboard-title-with-feedback-toolbar';
export const WEB_COMPONENT_CUSTOM_RULES = 'gz-custom-rules';
export const WEB_COMPONENT_CUSTOM_RULES_SIDE_PANEL = 'gz-custom-rules-side-panel';
export const WEB_COMPONENT_CUSTOM_RULES_GENERAL = 'gz-custom-rules-general';
export const WEB_COMPONENT_CUSTOM_RULES_RULE_OUTCOME = 'gz-custom-rules-rule-outcome';
export const WEB_COMPONENT_CUSTOM_RULES_TARGETS = 'gz-custom-rules-targets';
export const WEB_COMPONENT_GZ_ADD_RULE = 'gz-add-rule';
export const WEB_COMPONENT_GZ_RULE = 'gz-rule';
export const WEB_COMPONENT_GZ_RULE_DEFINITION = 'gz-rule-definition';
export const WEB_COMPONENT_GZ_RULE_SETTINGS = 'gz-rule-settings';
export const WEB_COMPONENT_GZ_RULE_CONFIGURATION = 'gz-rule-configuration';
export const WEB_COMPONENT_GZ_RULE_OUTCOME = 'gz-rule-outcome';
export const WEB_COMPONENT_YARA_DEFINITION = 'gz-yara-definition';
export const WEB_COMPONENT_GZ_YARA_DEFINITION = 'gz-gz-yara-definition';
export const WEB_COMPONENT_RULE_TARGETS = 'gz-rule-targets';
export const WEB_COMPONENT_GZ_COMPLEX_SEARCH = 'gz-complex-search';
export const WEB_COMPONENT_GZ_CUSTOM_INPUT_SEARCH = 'gz-custom-input-search';
export const WEB_COMPONENT_SELECTED_TAGS = 'gz-selected-tags';
export const WEB_COMPONENT_ENDPOINT_TAG = 'gz-endpoint-tag';
export const WEB_COMPONENT_GZ_COMPLEX_ENUM_FILTER = 'gz-complex-enum-filter';
export const WEB_COMPONENT_GRID_CELL_LINK = 'gz-grid-cell-link';
export const WEB_COMPONENT_GZ_COMPLEX_ENUM_LIST = 'gz-complex-enum-list';
export const WEB_COMPONENT_BACKEND_ENUM_FILTER = 'backend-enum-filter';
export const WEB_COMPONENT_GZ_FONT_SIZE_CHANGER = 'gz-font-size-changer';
export const WEB_COMPONENT_GZ_HELP_AND_SUPPORT = 'gz-help-and-support';
export const WEB_COMPONENT_GZ_HELP_AND_SUPPORT_TABS = 'gz-help-and-support-tabs';
export const WEB_COMPONENT_WEB_ACCESS_CONTROL_SCHEDULER_APP = 'gz-web-access-control-scheduler-app';
export const WEB_COMPONENT_WEB_ACCESS_CONTROL_SCHEDULER_FORM = 'gz-web-access-control-scheduler-form';
export const WEB_COMPONENT_GZ_TEXT_ANIMATION = 'gz-text-animation';
export const WEB_COMPONENT_AI_CHAT = 'gz-ai-chat';
export const WEB_COMPONENT_GZ_AVAILABLE_ITEMS_CARD = 'gz-available-items-card';
export const WEB_COMPONENT_GZ_CHAT_CARD = 'gz-chat-card';
export const WEB_COMPONENT_GZ_TEXTAREA_WITH_SUGGESTIONS = 'gz-textarea-with-suggestions';
export const WEB_COMPONENT_GZ_CHAT_INCIDENT_UPDATE = 'gz-chat-incident-update';
export const WEB_COMPONENT_GZ_STAR_RATING = 'gz-star-rating';
export const WEB_COMPONENT_GZ_AI_FEEDBACK = 'gz-ai-feedback';
export const WEB_COMPONENT_GZ_LABEL_SWITCH = 'gz-label-switch';
export const WEB_COMPONENT_GENERAL_CHART = 'gz-general-chart';
export const WEB_COMPONENT_LP_WIDGET_WELCOME = 'gz-lp-widget-welcome';
export const WEB_COMPONENT_GZ_PRICE_DISCOUNT = 'gz-price-discount';
export const WEB_COMPONENT_GZ_PURCHASE_CARD_LAYOUT = 'gz-purchase-card-layout';
export const WEB_COMPONENT_GZ_BUY_PRODUCT_CARD = 'gz-buy-product-card';
export const WEB_COMPONENT_GZ_INCREMENT_INPUT = 'gz-increment-input';
export const WEB_COMPONENT_GZ_PURCHASE_PAGE = 'gz-purchase-page';
export const WEB_COMPONENT_GZ_DONUT_CHART_WIDGET = 'gz-donut-chart-widget';
export const WEB_COMPONENT_GZ_MEGA_MENU = 'gz-mega-menu';
export const WEB_COMPONENT_ANTIMALWARE_ANTI_TAMPERING_PANEL = 'gz-antimalware-anti-tampering-panel';
export const WEB_COMPONENT_RISK_INCIDENT_SIDE_PANEL = 'gz-risk-incident-side-panel';
export const WEB_COMPONENT_GZ_MAP_WITH_BUBBLES_CHART = 'gz-map-with-bubbles-chart';
export const WEB_COMPONENT_GZ_DATA_TABLE = 'gz-data-table';
export const WEB_COMPONENT_GZ_GENERIC_OVERLAY = 'gz-generic-overlay';
export const WEB_COMPONENT_GZ_SINGLE_SELECT_LIST_COUNTRY_CODE = 'gz-single-select-list-country-code';
export const WEB_COMPONENT_GZ_SINGLE_SELECT_COUNTRY_CODE = 'gz-single-select-country-code';
export const WEB_COMPONENT_SUBMIT_TO_LABS = 'gz-submit-to-labs';
export const WEB_COMPONENT_EASM_SCAN_CONFIGURATION = 'gz-easm-scan-configuration';
export const WEB_COMPONENT_EASM_SCAN_CONFIGURATION_ITEM_FORM = 'gz-easm-scan-configuration-item-form';
export const WEB_COMPONENT_EASM_SCAN_CONFIGURATION_ASSET_GRID = 'gz-easm-scan-configuration-asset-grid';
export const WEB_COMPONENT_EASM_SCAN_CONFIGURATION_SCHEDULER = 'gz-easm-scan-configuration-scheduler';
export const WEB_COMPONENT_FINDING_DETAILS = 'gz-finding-details';
export const WEB_COMPONENT_SUSPECTED_ACTORS_CARD = 'gz-suspected-actors-card';
export const WEB_COMPONENT_USER_DETAILS = 'user-details';
export const WEB_COMPONENT_USER_DETAILS_PARAMS = 'user-extra-details';
export const WEB_COMPONENT_GZ_DOUBLE_COLUMN_DETAILS = 'gz-double-column-details';
export const WEB_COMPONENT_GZ_BULLET = 'gz-bullet';
export const WEB_COMPONENT_SELECTABLE_TABLE_ROW_GROUP = 'gz-selectable-table-row-group';
export const WEB_COMPONENT_MAINTENANCE_WINDOW_MANUALLY_APPROVED_PATCHES_SELECTOR =
  'gz-maintenance-window-manually-approved-patches-selector';
export const WEB_COMPONENT_POLICY_PANEL_ACCORDION_BUTTONS = 'gz-policy-panel-accordion-buttons';
export const WEB_COMPONENT_POLICY_PANEL_ACCORDION_NAVIGATION_HEADER = 'gz-policy-panel-accordion-navigation-header';
export const WEB_COMPONENT_POLICY_PANEL_ACCORDION_TEMPLATE = 'gz-policy-panel-accordion-template';
export const WEB_COMPONENT_SEARCHABLE_POLICY_PANEL_COMPONENT = 'gz-searchable-policy-panel-component';
export const WEB_COMPONENT_POLICY_PANEL_INDICATORS_OF_RISK_GENERAL = 'gz-policy-panel-indicators-of-risk-general';
export const WEB_COMPONENT_POLICY_PANEL_BLOCKLIST_RULES_GENERAL = 'gz-policy-panel-blocklist-rules';
export const WEB_COMPONENT_POLICY_PANEL_EDR_SENSOR_GENERAL = 'gz-policy-panel-edr-sensor-general';
export const WEB_COMPONENT_POLICY_PANEL_INTEGRITY_MONITOR_REAL_TIME = 'gz-policy-panel-integrity-monitor-real-time';
export const WEB_COMPONENT_POLICY_PANEL_INTEGRITY_MONITOR_RULE_SETS = 'gz-policy-panel-integrity-monitor-rule-sets';
export const WEB_COMPONENT_POLICY_PANEL_PATCH_MANAGEMENT_GENERAL = 'gz-policy-panel-patch-management-general';
export const WEB_COMPONENT_POLICY_PANEL_PATCH_MANAGEMENT_MAINTENANCE_WINDOWS_CONTAINER =
  'gz-policy-panel-patch-management-maintenance-windows-container';
export const WEB_COMPONENT_POLICY_PANEL_PATCH_MANAGEMENT_MAINTENANCE_WINDOW_SUMMARIES =
  'gz-policy-panel-patch-management-maintenance-window-summaries';
export const WEB_COMPONENT_POLICY_PANEL_PATCH_MANAGEMENT_MAINTENANCE_WINDOW_SUMMARY =
  'gz-policy-panel-patch-management-maintenance-window-summary';
export const WEB_COMPONENT_POLICY_PANEL_STORAGE_PROTECTION_ICAP = 'gz-policy-panel-storage-protection-icap';
export const WEB_COMPONENT_GZ_CUSTOM_TEMPLATE_LIST = 'gz-custom-template-list';
export const WEB_COMPONENT_POLICY_PANEL_STORAGE_PROTECTION_EXCLUSIONS = 'gz-policy-panel-storage-protection-exclusions';
export const WEB_COMPONENT_POLICY_PANEL_STORAGE_PROTECTION_EXCLUSION_ITEM =
  'gz-policy-panel-storage-protection-exclusion-item';
export const WEB_COMPONENT_POLICY_PANEL_STORAGE_PROTECTION_EXCLUSIONS_GRID =
  'gz-policy-panel-storage-protection-exclusions-grid';
export const WEB_COMPONENT_POLICY_PANEL_IMPORT_FILE_INPUT = 'gz-policy-panel-import-file-input';
export const WEB_COMPONENT_POLICY_PANEL_ENCRYPTION_GENERAL = 'gz-policy-panel-encryption-general';
export const WEB_COMPONENT_POLICY_PANEL_ENCRYPTION_EXCLUSION_ITEM = 'gz-policy-panel-encryption-exclusion-item';
export const WEB_COMPONENT_POLICY_PANEL_ENCRYPTION_EXCLUSIONS_GRID = 'gz-policy-panel-encryption-exclusions-grid';
export const WEB_COMPONENT_COMPLIANCE_STANDARDS = 'gz-compliance-standards';
export const WEB_COMPONENT_SUBMIT_TO_SANDBOX_PANEL = 'gz-submit-to-sandbox-panel';
export const WEB_COMPONENT_SUBMIT_TO_SANDBOX_SAMPLES_FORM = 'gz-submit-to-sandbox-samples-form';
export const WEB_COMPONENT_SUBMIT_TO_SANDBOX_SETTINGS_FORM = 'gz-submit-to-sandbox-settings-form';
export const WEB_COMPONENT_GZ_INPUT_TEXT_GRID = 'gz-input-text-grid';
export const WEB_COMPONENT_POLICY_PANEL_DEVICE_CONTROL_RULES = 'gz-policy-panel-device-control-rules';
export const WEB_COMPONENT_POLICY_PANEL_DEVICE_CONTROL_RULES_TABLE = 'gz-policy-panel-device-control-rule-table';
export const WEB_COMPONENT_CLOUD_STAGING_LIST = 'gz-cloud-staging-list-app';
export const WEB_COMPONENT_CLOUD_STAGING_SIDE_BAR = 'cloud-staging-side-bar';
export const WEB_COMPONENT_POLICY_PANEL_RELAY_COMMUNICATION = 'gz-policy-panel-relay-communication';
export const WEB_COMPONENT_GZ_INTEGRATIONS_MARKETPLACE_CARD = 'gz-integrations-marketplace-card';
export const WEB_COMPONENT_INTEGRATIONS_MARKETPLACE_HISTORY_LOGS = 'gz-integrations-marketplace-history-logs';
export const WEB_COMPONENT_POLICY_PANEL_RELAY_UPDATE = 'gz-policy-panel-relay-update';
export const WEB_COMPONENT_POLICY_PANEL_RELAY_UPDATE_LOCATION_ITEM = 'gz-policy-panel-relay-update-location-item';
export const WEB_COMPONENT_POLICY_PANEL_RELAY_UPDATE_LOCATIONS_TABLE = 'gz-policy-panel-relay-update-locations-table';
export const WEB_COMPONENT_POLICY_PANEL_RELAY_COMMUNICATION_WHITELIST_ITEM =
  'gz-policy-panel-relay-communication-whitelist-item';
export const WEB_COMPONENT_POLICY_PANEL_RELAY_COMMUNICATION_WHITELIST_TABLE =
  'gz-policy-panel-relay-communication-whitelist-table';
export const WEB_COMPONENT_POLICY_PANEL_LIVE_SEARCH = 'gz-policy-panel-live-search';
export const WEB_COMPONENT_GZ_EXCHANGE_SCAN_TASK = 'gz-exchange-scan-task';
export const WEB_COMPONENT_GZ_INPUT_NUMBER_WITH_DROPDOWN = 'gz-input-number-with-dropdown';
export const WEB_COMPONENT_GROUP_ATTRIBUTION_IOC_SIDE_PANEL = 'gz-group-attribution-ioc-side-panel';
export const WEB_COMPONENT_ACTOR_CARD = 'gz-actor-card';
export const WEB_COMPONENT_GROUP_ATTRIBUTION_MITRE_SIDE_PANEL = 'gz-group-attribution-mitre-side-panel';
export const WEB_COMPONENT_GROUP_ATTRIBUTION_CVE_SIDE_PANEL = 'gz-group-attribution-cve-side-panel';
export const WEB_COMPONENT_GZ_DARK_MODE_TOGGLE = 'gz-dark-mode-toggle';
export const WEB_COMPONENT_POLICY_PANEL_SANDBOX_ENDPOINT_SENSOR = 'gz-policy-panel-sandbox-endpoint-sensor';
export const WEB_COMPONENT_POLICY_PANEL_SANDBOX_NETWORK_SENSOR = 'gz-policy-panel-sandbox-network-sensor';
export const WEB_COMPONENT_POLICY_PANEL_SANDBOX_ICAP_SENSOR = 'gz-policy-panel-sandbox-icap-sensor';
export const WEB_COMPONENT_POLICY_PANEL_SANDBOX_MANAGER = 'gz-policy-panel-sandbox-manager';
export const WEB_COMPONENT_GZ_SELECTED_LIST = 'gz-selected-list';
export const WEB_COMPONENT_GZ_SELECTED_LIST_ITEM = 'gz-selected-list-item';
export const WEB_COMPONENT_GZ_SELECTED_LIST_ITEM_GENERATOR = 'gz-selected-list-item-generator';
export const WEB_COMPONENT_INTEGRATIONS_MARKETPLACE_APP_CONTAINER = 'gz-integrations-marketplace-app-container';
export const WEB_COMPONENT_INTEGRATIONS_MARKETPLACE_GRID_INSTALLED = 'gz-integrations-marketplace-grid-installed';
export const WEB_COMPONENT_INTEGRATIONS_MARKETPLACE_GRID_AVAILABLE = 'gz-integrations-marketplace-grid-available';
export const WEB_COMPONENT_DEVICE_CONTROL_RULES_CONTAINER = 'gz-device-control-rules-container';
export const WEB_COMPONENT_POLICY_PANEL_APPLICATION_CONTROL_GENERAL = 'gz-policy-panel-application-control-general';
export const WEB_COMPONENT_POLICY_PANEL_APPLICATION_CONTROL_RULES_GRID =
  'gz-policy-panel-application-control-rules-grid';
export const WEB_COMPONENT_POLICY_PANEL_APPLICATION_CONTROL_RULES_ITEM_DEPRECATED =
  'gz-policy-panel-application-control-rules-item-deprecated';
export const WEB_COMPONENT_POLICY_PANEL_DEVICE_CONTROL_EXCLUSIONS = 'gz-policy-panel-device-control-exclusions';
export const WEB_COMPONENT_POLICY_PANEL_DEVICE_CONTROL_EXCLUSIONS_GRID =
  'gz-policy-panel-device-control-exclusions-grid';
export const WEB_COMPONENT_MANUAL_ADD_EXCEPTION_CONTAINER = 'gz-device-control-manual-add-exception-container';
export const WEB_COMPONENT_DISCOVERED_DEVICES_ADD_EXCEPTION_CONTAINER =
  'gz-device-control-discovered-devices-add-exception-container';
export const WEB_COMPONENT_GZ_CAROUSEL_INFO_CARD = 'gz-carousel-info-card';
export const WEB_COMPONENT_DISCOVERED_DEVICES_GRID_WEB_COMPONENT =
  'gz-device-control-discovered-devices-grid-web-component';
export const WEB_COMPONENT_READ_ONLY_GRID = 'gz-read-only-grid';
export const WEB_COMPONENT_POLICY_PANEL_APPLICATION_CONTROL_RULES_FORM =
  'gz-policy-panel-application-control-rules-form';
export const WEB_COMPONENT_POLICY_PANEL_APPLICATION_CONTROL_TARGET_ITEM =
  'gz-policy-panel-application-control-target-item';
export const WEB_COMPONENT_POLICY_PANEL_APPLICATION_CONTROL_TARGETS_TABLE =
  'gz-policy-panel-application-control-targets-table';
export const WEB_COMPONENT_GZ_ISOLATE_ENDPOINT_TASK = 'gz-isolate-endpoint-task';
export const WEB_COMPONENT_GZ_REMOVE_FROM_ISOLATION_TASK = 'gz-remove-from-isolation-task';
export const WEB_COMPONENT_MDR_CONTACT_IMPORT_OPTIONS = 'gz-mdr-contact-import-options';
export const WEB_COMPONENT_MDR_CONTACT_DETAILS_SECTION = 'gz-mdr-contact-details-section';
export const WEB_COMPONENT_MDR_CONTACT_DETAILS_FORM = 'gz-mdr-contact-details-form';
export const WEB_COMPONENT_ATTACK_SURFACE_REDUCTION_POTENTIAL = 'gz-phasr-attack-surface-reduction';
export const WEB_COMPONENT_PHASR_DETECTED_INCIDENTS = 'gz-phasr-detected-incidents';
export const WEB_COMPONENT_GATHERING_DATA_INFO = 'phasr-gathering-data-info';
export const WEB_COMPONENT_GZ_WIDGET_SECTION_WITH_ICONS_AND_PERCENTAGE_ITEM =
  'gz-widget-section-with-icons-and-percentage-item';
export const WEB_COMPONENT_PHASR_CATEGORIES_WIDGET_TEMPLATE = 'gz-phasr-categories-widget-template';
export const WEB_COMPONENT_PHASR_TAMPERING_TOOLS = 'gz-phasr-tampering-tools';
export const WEB_COMPONENT_PHASR_MINERS = 'gz-phasr-miners';
export const WEB_COMPONENT_PHASR_HACKTOOLS = 'gz-phasr-hacktools';
export const WEB_COMPONENT_PHASR_REMOTE_ADMIN_TOOLS = 'gz-phasr-remote-admin-tools';
export const WEB_COMPONENT_PHASR_OFF_LAND_BINARIES = 'gz-phasr-off-land-binaries';
export const WEB_COMPONENT_PHASR_TOP_RECOMMENDATIONS = 'gz-phasr-top-recommendations';
export const WEB_COMPONENT_AFFECTED_RESOURCES_SIDE_MENU = 'categories-side-menu';
export const WEB_COMPONENT_AFFECTED_IDENTITIES_SIDE_MENU = 'affected-identities-side-menu';
export const WEB_COMPONENT_POLICY_PANEL_NSX = 'gz-policy-panel-nsx';
export const WEB_COMPONENT_EDIT_POLICY_ASSIGNMENT_PANEL = 'gz-edit-policy-assignment-panel';
export const WEB_COMPONENT_POLICY_PANEL_FIREWALL_SETTINGS = 'gz-policy-panel-firewall-settings';
export const WEB_COMPONENT_POLICY_PANEL_FIREWALL_SETTINGS_EXCLUSIONS_TABLE =
  'gz-policy-panel-firewall-settings-exclusions-table';
export const WEB_COMPONENT_POLICY_PANEL_FIREWALL_SETTINGS_EXCLUSION_ITEM =
  'gz-policy-panel-firewall-settings-exclusion-item';
export const WEB_COMPONENT_POLICY_PANEL_FIREWALL_NETWORK = 'gz-policy-panel-firewall-network';
export const WEB_COMPONENT_POLICY_PANEL_FIREWALL_NETWORK_ITEM = 'gz-policy-panel-firewall-network-item';
export const WEB_COMPONENT_POLICY_PANEL_FIREWALL_NETWORK_TABLE = 'gz-policy-panel-firewall-network-table';
export const WEB_COMPONENT_POLICY_PANEL_FIREWALL_ADAPTERS_TABLE = 'gz-policy-panel-firewall-adapters-table';
export const WEB_COMPONENT_POLICY_PANEL_FIREWALL_ADVANCED = 'gz-policy-panel-firewall-advanced';
export const WEB_COMPONENT_POLICY_PANEL_FIREWALL_ADVANCED_RULES_GRID = 'gz-policy-panel-firewall-advanced-rules-grid';
export const WEB_COMPONENT_POLICY_PANEL_FIREWALL_ADVANCED_RULES_FORM = 'gz-policy-panel-firewall-advanced-rules-form';
export const WEB_COMPONENT_CARD_PANEL = 'gz-card-panel';
export const WEB_COMPONENT_INTEGRATIONS_FORM = 'gz-integrations-form';
export const WEB_COMPONENT_SAVE_INTEGRATION = 'gz-save-integration';
export const WEB_COMPONENT_VCENTER = 'gz-vcenter';
export const WEB_COMPONENT_INTEGRATION_CONTAINER_IMAGE_SCANNER = 'gz-integration-container-image-scanner';
export const WEB_COMPONENT_PHONE_INPUT = 'gz-phone-input';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_TRAFFIC = 'gz-policy-panel-content-control-traffic';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_TRAFFIC_EXCLUSION_ITEM =
  'gz-policy-panel-content-control-traffic-exclusion-item';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_TRAFFIC_EXCLUSIONS_GRID =
  'gz-policy-panel-content-control-traffic-exclusions-grid';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_DATA_PROTECTION =
  'gz-policy-panel-content-control-data-protection';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_NETWORK_MONITOR =
  'gz-policy-panel-content-control-network-monitor';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_WEB = 'gz-policy-panel-content-control-web';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_WEB_ACCESS_EXCEPTIONS_ITEM =
  'gz-policy-panel-content-control-web-access-exceptions-item';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_WEB_ACCESS_EXCEPTIONS_GRID =
  'gz-policy-panel-content-control-web-access-exceptions-grid';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_DATA_PROTECTION_RULES_GRID =
  'gz-policy-panel-content-control-data-protection-rules-grid';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_DATA_PROTECTION_RULES_GRID_LIGHT =
  'gz-policy-panel-content-control-data-protection-rules-grid-light';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_DATA_PROTECTION_RULES_FORM =
  'gz-policy-panel-content-control-data-protection-rules-form';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_DATA_PROTECTION_EXCLUSIONS_GRID =
  'gz-policy-panel-content-control-data-protection-exclusions-grid';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_DATA_PROTECTION_EXCLUSIONS_FORM =
  'gz-policy-panel-content-control-data-protection-exclusions-form';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_APPLICATION_RULES_GRID =
  'gz-policy-panel-content-control-application-rules-grid';
export const WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_APPLICATION_RULES_FORM =
  'gz-policy-panel-content-control-application-rules-form';
export const WEB_COMPONENT_GZ_TIME_RANGE_SLIDER = 'gz-time-range-slider';
export const WEB_COMPONENT_PHASR_RECOMMENDATIONS = 'gz-phasr-recommendations';
export const WEB_COMPONENT_PHASR_RECOMMENDATIONS_GRID = 'gz-phasr-recommendations-grid';
export const WEB_COMPONENT_PHASR_SIDE_PANEL = 'gz-phasr-side-panel';
export const WEB_COMPONENT_PHASR_MONITORED_RULES = 'gz-phasr-monitored-rules';
export const WEB_COMPONENT_PHASR_MONITORED_RULES_GRID = 'gz-phasr-monitored-rules-grid';
export const WEB_COMPONENT_PHASR_MONITORED_RULES_DETAILS_PANEL = 'gz-phasr-monitored-rules-details-panel';
export const WEB_COMPONENT_GZ_MOVE_TO_ACTION = 'gz-move-to-action';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_PROTECTION_GENERAL = 'gz-policy-panel-exchange-protection-general';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_PROTECTION_ANTI_SPOOFING_GRID =
  'gz-policy-panel-exchange-protection-anti-spoofing-grid';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_PROTECTION_ANTI_SPOOFING_ITEM =
  'gz-policy-panel-exchange-protection-anti-spoofing-item';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_PROTECTION_USER_GROUPS_GRID =
  'gz-policy-panel-exchange-protection-user-groups-grid';
export const WEB_COMPONENT_EDIT_USER_GROUP_CONTAINER = 'gz-policy-panel-exchange-protection-edit-user-group-container';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE = 'gz-policy-panel-exchange-antimalware';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_SETTINGS_FORM =
  'gz-policy-panel-exchange-antimalware-settings-form';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_ON_DEMAND_SCAN_CREDENTIALS_FORM =
  'gz-policy-panel-exchange-antimalware-on-demand-scan-credentials-form';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_RULES_GRID =
  'gz-policy-panel-exchange-antimalware-rules-grid';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_RULES_FORM =
  'gz-policy-panel-exchange-antimalware-rules-form';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_USER_GROUPS_GRID = 'gz-policy-panel-exchange-user-groups-grid';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_EXCLUSIONS_GRID =
  'gz-policy-panel-exchange-antimalware-exclusions-grid';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_EXCLUSIONS_FORM =
  'gz-policy-panel-exchange-antimalware-exclusions-form';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_SCAN_TASKS_GRID =
  'gz-policy-panel-exchange-antimalware-scan-tasks-grid';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_SCAN_TASKS_FORM =
  'gz-policy-panel-exchange-antimalware-scan-tasks-form';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_SCAN_TASKS_EXCLUSIONS_GRID =
  'gz-policy-panel-exchange-antimalware-scan-tasks-exclusions-grid';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_SCAN_TASKS_EXCLUSIONS_ITEM =
  'gz-policy-panel-exchange-antimalware-scan-tasks-exclusions-item';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_CONTENT_CONTROL = 'gz-policy-panel-exchange-content-control';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_CONTENT_CONTROL_ATTACHMENT_FILTERING_RULES_GRID =
  'gz-policy-panel-exchange-content-control-attachment-filtering-rules-grid';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_CONTENT_CONTROL_ATTACHMENT_FILTERING_RULES_FORM =
  'gz-policy-panel-exchange-content-control-attachment-filtering-rules-form';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_CONTENT_CONTROL_CONTENT_FILTERING_RULES_GRID =
  'gz-policy-panel-exchange-content-control-content-filtering-rules-grid';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_CONTENT_CONTROL_CONTENT_FILTERING_RULES_FORM =
  'gz-policy-panel-exchange-content-control-content-filtering-rules-form';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_CONTENT_CONTROL_CONTENT_FILTERING_BY_GRID =
  'gz-policy-panel-exchange-content-control-content-filtering-by-grid';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_CONTENT_CONTROL_CONTENT_FILTERING_BY_ITEM =
  'gz-policy-panel-exchange-content-control-content-filtering-by-item';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_PROTECTION_ANTI_SPOOFING_CONTAINER =
  'gz-policy-panel-exchange-protection-anti-spoofing-container';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTISPAM = 'gz-policy-panel-exchange-antispam';
export const WEB_COMPONENT_EXCHANGE_ANTISPAM_SETTINGS_TABLE = 'gz-policy-panel-exchange-antispam-settings-table';
export const WEB_COMPONENT_EXCHANGE_ANTISPAM_SETTINGS_ITEM = 'gz-policy-panel-exchange-antispam-settings-item';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTISPAM_RULES_GRID = 'gz-policy-panel-exchange-antispam-rules-grid';
export const WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTISPAM_RULES_FORM = 'gz-policy-panel-exchange-antispam-rules-form';
export const WEB_COMPONENT_SET_AD_INTEGRATOR = 'gz-set-ad-integrator';
export const WEB_COMPONENT_REMOVE_AD_INTEGRATOR = 'gz-remove-ad-integrator';
export const WEB_COMPONENT_REMOVE_AD_INTEGRATION = 'gz-remove-ad-integration';
export const WEB_COMPONENT_PHASR_RECOMMENDATION_SIDE_MENU = 'gz-phasr-recommendation-side-menu';
export const WEB_COMPONENT_WEB_ACCESS_CONTROL_CUSTOM_PAGES_APP = 'gz-web-access-control-custom-pages-app';
export const WEB_COMPONENT_WEB_ACCESS_CONTROL_CUSTOM_PAGES_FORM = 'gz-web-access-control-custom-pages-form';
export const WEB_COMPONENT_SET_VMWARE_INTEGRATOR = 'gz-set-vmware-integrator';
export const WEB_COMPONENT_UNSET_VMWARE_INTEGRATOR = 'gz-unset-vmware-integrator';
export const WEB_COMPONENT_PHASR_APPLY_ACTION_PANEL = 'gz-phasr-apply-action-panel';
export const WEB_COMPONENT_PHASR_BEHAVIORAL_PROFILES_RESTRICT = 'gz-phasr-behavioral-profiles-restrict';
export const WEB_COMPONENT_INCIDENTS_ACTIVITY_PANEL = 'gz-incidents-activity-panel';
export const WEB_COMPONENT_ALERT_DETAILS = 'gz-alert-details';
export const WEB_COMPONENT_GZ_ALERT_GROUP_DETAILS_SIDEPANEL = 'gz-alert-group-details-sidepanel';
export const WEB_COMPONENT_GZ_SINGLE_SELECT_LOADED = 'gz-single-select-loaded';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ANTI_TAMPERING = 'gz-policy-panel-antimalware-anti-tampering';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS = 'gz-policy-panel-antimalware-on-access';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS_UNIX_PATHS_TABLE =
  'gz-policy-panel-antimalware-on-access-unix-paths-table';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS_UNIX_PATHS_ITEM =
  'gz-policy-panel-antimalware-on-access-unix-paths-item';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_DYNAMIC_THREAT_DEFENSE =
  'gz-policy-panel-antimalware-dynamic-threat-defense';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ANTI_EXPLOIT = 'gz-policy-panel-antimalware-anti-exploit';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ANTI_EXPLOIT_APPS_TABLE =
  'gz-policy-panel-antimalware-anti-exploit-apps-table';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ANTI_EXPLOIT_APP_FORM =
  'gz-policy-panel-antimalware-anti-exploit-app-form';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_SECURITY_SERVERS = 'gz-policy-panel-antimalware-security-servers';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_SECURITY_SERVERS_SVA_IPS_TABLE =
  'gz-policy-panel-antimalware-security-servers-sva-ips-table';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_SECURITY_SERVERS_SVA_IPS_ITEM =
  'gz-policy-panel-antimalware-security-servers-sva-ips-item';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_EXECUTE = 'gz-policy-panel-antimalware-on-execute';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND = 'gz-policy-panel-antimalware-on-demand';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_SCAN_TASKS_GRID =
  'gz-policy-panel-antimalware-on-demand-scan-tasks-grid';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_SCAN_TASK_OPTIONS_FORM =
  'gz-policy-panel-antimalware-on-demand-scan-task-options-form';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_SCAN_TASK_TARGET_FORM =
  'gz-policy-panel-antimalware-on-demand-scan-task-target-form';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_SCAN_TASK_GENERAL_FORM =
  'gz-policy-panel-antimalware-on-demand-scan-task-general-form';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_SCAN_TASKS_FORM =
  'gz-policy-panel-antimalware-on-demand-scan-tasks-form';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_CONTEXTUAL_SCAN_FORM =
  'gz-policy-panel-antimalware-on-demand-contextual-scan-form';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_DEVICE_SCAN_FORM =
  'gz-policy-panel-antimalware-on-demand-device-scan-form';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_EXCLUSIONS_TABLE =
  'gz-policy-panel-antimalware-on-demand-exclusions-table';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_EXCLUSIONS_ITEM =
  'gz-policy-panel-antimalware-on-demand-exclusions-item';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_SCAN_TARGET_TABLE =
  'gz-policy-panel-antimalware-on-demand-scan-target-table';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_DEMAND_SCAN_TARGET_ITEM =
  'gz-policy-panel-antimalware-on-demand-scan-target-item';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_SETTINGS = 'gz-policy-panel-antimalware-settings';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_EXCLUSIONS = 'gz-policy-panel-antimalware-exclusions';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_EXCLUSIONS_GRID = 'gz-policy-panel-antimalware-exclusions-grid';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_EXCLUSIONS_ITEM = 'gz-policy-panel-antimalware-exclusions-item';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_EXCLUSIONS_LISTS_TABLE =
  'gz-policy-panel-antimalware-exclusions-lists-table';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_EXCLUSIONS_LIST_ITEM =
  'gz-policy-panel-antimalware-exclusions-list-item';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_EXCLUSIONS_LISTS = 'gz-policy-panel-antimalware-exclusions-lists';
export const WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_VENDORS_EXCLUSIONS_LISTS =
  'gz-policy-panel-antimalware-vendors-exclusions-lists';
export const WEB_COMPONENT_POLICY_PANEL_GENERAL_SECURITY_TELEMETRY = 'gz-policy-panel-general-security-telemetry';
export const WEB_COMPONENT_POLICY_PANEL_GENERAL_COMMUNICATION = 'gz-policy-panel-general-communication';
export const WEB_COMPONENT_POLICY_PANEL_ENDPOINT_COMMUNICATION_ASSIGNMENT_GRID =
  'gz-policy-panel-general-endpoint-communication-assignment-grid';
export const WEB_COMPONENT_POLICY_PANEL_COMMUNICATION_ENDPOINTS_ASSIGNMENT_ITEM =
  'gz-policy-panel-communication-endpoints-assignment-item';
export const WEB_COMPONENT_POLICY_PANEL_GENERAL_DETAILS = 'gz-policy-panel-general-details';
export const WEB_COMPONENT_POLICY_PANEL_GENERAL_ADVANCED = 'gz-policy-panel-general-advanced';
export const WEB_COMPONENT_POLICY_PANEL_GENERAL_NOTIFICATIONS = 'gz-policy-panel-general-notifications';
export const WEB_COMPONENT_POLICY_PANEL_GENERAL_INHERITANCE = 'gz-policy-panel-general-inheritance';
export const WEB_COMPONENT_POLICY_PANEL_GENERAL_INHERITANCE_ITEM = 'gz-policy-panel-general-inheritance-item';
export const WEB_COMPONENT_POLICY_PANEL_GENERAL_INHERITANCE_TABLE = 'gz-policy-panel-general-inheritance-table';
export const WEB_COMPONENT_POLICY_PANEL_GENERAL_UPDATE = 'gz-policy-panel-general-update';
export const WEB_COMPONENT_POLICY_PANEL_GENERAL_UPDATE_LOCATION_ITEM = 'gz-policy-panel-general-update-location-item';
export const WEB_COMPONENT_POLICY_PANEL_GENERAL_UPDATE_LOCATIONS_TABLE =
  'gz-policy-panel-general-update-locations-table';
export const WEB_COMPONENT_HORIZONTAL_STACKED_BAR_CHART = 'gz-horizontal-stacked-bar-chart';
export const WEB_COMPONENT_MDR_COMPANIES_GRID = 'gz-mdr-companies-grid';
export const WEB_COMPONENT_MDR_SECURITY_TELEMETRY_EXCLUSIONS_GRID = 'gz-mdr-security-telemetry-exclusions-grid';

export const WEB_COMPONENT_IZ_INTEGRATION = 'gz-iz-integration';
export const WEB_COMPONENT_GZ_MULTI_GAUGE = 'gz-multi-gauge';
export const WEB_COMPONENT_GZ_NAVIGATION_BUTTON = 'gz-navigation-button';
export const WEB_COMPONENT_GRID_VIEW_STATUS_CHIP = 'grid-view-status-chip';
